import React from "react";
import { connect } from "react-redux";
import { servicios } from "../properties";
import moment from "moment";
import {fnMoneda } from "../tools";

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
	};
};

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza,
		"listaFacturas": state.polizas.listaFacturas,
		"downloadProgress": state.global.downloadProgress,
		dispositivo: state.global.dispositivo,
		"ramo": state.polizas.ramoActual,
		BeneficiosDentalia:state.polizas.BeneficiosDentalia,
		TratamientoDentalia:state.polizas.TratamientoDentalia,
	
	};
};

class Dentalia extends React.Component {

	state={
		precioPublico:"",
		precioPreferencia:"",
		porcentajeAhorro:[],
		objAhorro:[],
		TratamientoDentalia: false,
		BeneficiosDentalia : false

	}

	

	componentWillReceiveProps(nextProps){
		
			if(nextProps.TratamientoDentalia){
				setTimeout(()=>{
					this.setState({TratamientoDentalia:nextProps.TratamientoDentalia})
				},2000)
			}

			if(nextProps.BeneficiosDentalia){
				setTimeout(()=>{
					this.setState({BeneficiosDentalia:nextProps.BeneficiosDentalia})
				},2000)
			}
	
	}


	tagEventCitaPortal(){
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: 'CALLTO_CITA_ASISTENCIA_DENTAL_PORTAL'
		});
	}
	tagEventCitaMovil(){
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: 'CALLTO_CITA_ASISTENCIA_DENTAL_APP'
		});
	}


	close = () => {
		$("#modal-" + this.props.modal).modal("toggle");
		this.setState({BeneficiosDentalia:false,TratamientoDentalia:false});
	} 
	


	render() {
		
		let beneficiosDM = this.state.BeneficiosDentalia;
		let beneficiosAhorroDM = this.state.TratamientoDentalia;

		return (
			<div className="mt-77B">
				<div className="modal-container Den">
				<div className="row col-lg-12 "><button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"><img src={ require("../img/x.svg") } alt="" /></button>
                </div>
				
					<div className="row">
                                <div className="col-xs-12 col-md-6 odd-card-dentalia">
                                        <div className="card Dent col-xs-12 col-md-12 col-lg-12">

                                        <div className="row col-lg-12 encabezadoDentaliaTitle">
                                                            <div className="col-md-1 col-xs-1">
                                                                <img className="EncabezadoIMG" src={ require("../img/circle-poliza.svg") }/> 
                                                            </div>
                                                              <div className="col-md-11 col-xs-10">
                                                                    <h5 className="EncabezadosDentalia">Beneficios sin costo </h5>
                                                              </div>
                                                              
										 </div>          

										{ this.props.ramo === "G" ? 
										<div className="row col-xs-12 col-md-12 col-lg-12">
                                                           <div class="row col-lg-12">
                                                               <p className="TexDen"> Con tu <span className="GMMSV">Seguro Médico GNP</span>, 
																			cuentas con Asistencia Dental que te brinda:
                                                                </p> 
                                                           </div>
											 </div>:
											
											<div className="row col-xs-12 col-md-12 col-lg-12">
                                                           <div class="row col-lg-12">
                                                               <p className="TexDen"> Con tu <span className="GMMSV">Seguro de Vida GNP</span>, 
																			cuentas con Asistencia Dental que te brinda:
                                                                </p> 
                                                           </div>
											 </div>
										}

										<div>

									

										</div>
									
									<div className="row col-xs-12 col-md-12 col-lg-12 puntosBeneficios">
										
									

										<ul>
											{beneficiosDM.beneficios && beneficiosDM.beneficios.map((beneficios,i)=>
											<li key={i} ><span className="orange-point-Dentalia"></span>{beneficios}
												</li>
											)}
										</ul>
										
									</div>	


									<div className="row col-xs-12 col-md-12 col-lg-12">
												<div class="row col-lg-12">
                                   	                            <p> Estos servicios equivalen a <span className="GMMSV">${fnMoneda(this.state.BeneficiosDentalia.montoAhorro)}</span> si los realizas en una clínica Dental 
																	sin el beneficio de tu Póliza GNP.    
                                                                </p> 
                                               </div>
										
									</div>


									<div className="row col-lg-12 col-md-12">
												
                                   	                            <p className="denCenterTex denCenterTexMa" >Programa tu cita en la clínica más cercana    
                                                                </p> 
                                               
										
									</div>
												

									<div className="row col-lg-12 col-md-12 col-xs-12">
                                            <div className="BorderDescuentoN numeroT">
											
												{	
													this.props.dispositivo ==="web"?
													<a className="numeroLinkDEn" onClick={this.tagEventCitaPortal.bind(this)} href="tel:+8000033682,1" >  
														<img src={ require("../img/telefono.svg.svg") } className="telDentalia" /> 
														800-00-33-682	
													</a> :

													<a className="numeroLinkDEn" onClick={this.tagEventCitaMovil.bind(this)} href="tel:+8000033682,1">  
														<img src={ require("../img/telefono.svg.svg") } className="telDentalia"/>
															Aquí	

														</a> 

												}                  			
					
											</div>	
									</div>	

										{
											this.props.ramo === "G" ? 
											<div className="row col-lg-12 col-xs-12 FootDenBen">
					
												<div className="row col-lg-12 col-xs-12">
															<p className="footerDentalia"> *Indicada por el odontólogo o especialista. Aplica para radiografía, aleta de mordida, oclusal, periapical
																y serie de radiografía de 14 (RX).    
																			</p> 		
												</div>	
												
												<div className="row col-lg-12 col-xs-12">
														
														<p className="footerDentalia">Dentalia se hace responsable de los servicios prestados a
														trav&eacute;s de su red de cl&iacute;nicas y m&eacute;dicos en convenio, por lo que
														cualquier duda o aclaraci&oacute;n deber&aacute; ser dirigida a <a href="http://www.dentalia.com">dentalia.mx </a> o Línea GNP.
														</p>
												</div>
											</div>	
											:null		
										}
							
											{
											this.props.ramo === "V" ? 
											<div className="row col-lg-12 col-xs-12 FootDenBenvida">				
													<div className="row col-lg-12 col-xs-12 ">
															<p className="footerDentalia">Dentalia se hace responsable de los servicios prestados a
															trav&eacute;s de su red de cl&iacute;nicas y m&eacute;dicos en convenio, por lo que
															cualquier duda o aclaraci&oacute;n deber&aacute; ser dirigida a <a href="http://www.dentalia.com">dentalia.mx</a> o Línea GNP.
															</p>
												</div>
											</div>	
											:null
											}

									  </div> 
                                    
                                </div>
                        
                        
                        
                        
                        
                        <div className="col-xs-12 col-md-6 odd-card-dentalia ">
                            <div className="card Dent col-xs-12 col-md-12 col-lg-12">

                            <div className="row col-lg-12 col-md-12 col-xs-12 encabezadoDentaliaTitle">
                                                            <div className="col-md-1 col-xs-1">
                                                                <img className="EncabezadoIMG" src={ require("../img/circle-poliza.svg") }/> 
                                                            </div>
                                                              <div className="col-md-11 col-xs-10">
                                                                    <h5 className="EncabezadosDentalia">Descuentos </h5>
                                                              </div>
                                                              
                             </div>   

                                          { this.props.ramo === "G" ? 
                                                     <div className="row col-xs-12 col-md-12 col-lg-12">
                                                           <div class="row col-lg-12 col-xs-12">
                                                               <p className="TexDen"> Con tu <span className="GMMSV">Seguro Médico GNP</span>, cuentas con descuentos en
                                                                tratamientos dentales que puedes utilizar las veces que sean necesarias:
                       
                                                                </p> 
																            
									

                                                           </div>
													</div>:
													<div className="row col-xs-12 col-md-12 col-lg-12">
													<div class="row col-lg-12 col-xs-12">
														<p className="TexDen"> Con tu <span className="GMMSV">Seguro de Vida GNP</span>, cuentas con descuentos en
														 tratamientos dentales que puedes utilizar las veces que sean necesarias:
				
														 </p> 
																	 
							 

													</div>
											 </div>

													
										  }		


								{
									this.props.ramo === "G" ? 
								
                                 <div>                
                                            <div className="row col-lg-12 col-sm-12">
                                           		 <div className="BorderDescuento col-xs-12">

                                                     <thead class="BorderDescuento">
                                                            <tr>
																<th className="TexDen">
																
																	<div class="row col-lg-3 ">
                                                                                <p className=" numeroPorcenaje col-lg-3" >{		beneficiosDM.descuentos && beneficiosDM.descuentos.length ? beneficiosDM.descuentos[0].valor : ""}%</p>
                                                                    </div>	
															
																</th>
														
                                                                
                                                                    <div class="row col-lg-3">
                                                                         
                                                                            <p className="TexDen">
																			{
																				beneficiosDM.descuentos && beneficiosDM.descuentos.length ? 
																				beneficiosDM.descuentos[0].descripcion
																				:""
																			
																			}
																			</p>
                                                                            
                                                                     
                                                                    </div>   
                                                                
                                                            </tr>
                                                    </thead>

                           
                                                </div>      
                                            </div>   

															
											<div className="row col-lg-12 col-sm-12">
												<div className="BorderDescuento col-xs-12">
												<thead class="BorderDescuento TexDen">
                                                            <tr>
                                                                <th className=" TexDen">
                                                                        <div class="row col-lg-3 ">
                                                                                <p className=" numeroPorcenaje col-lg-3" >{		beneficiosDM.descuentos && beneficiosDM.descuentos.length ? beneficiosDM.descuentos[1].valor : ""}%</p>
                                                                         </div>

                                                                </th>
                                                                
                                                                    <div class="row col-lg-3">
                                                                            
                                                                            <p className=" TexDen TexDenMargin">{
																				beneficiosDM.descuentos && beneficiosDM.descuentos.length ? 
																				beneficiosDM.descuentos[1].descripcion
																				:""
																			
																			}</p>
                                                                            
                                                
                                                                    </div>   
                                                            
                                                            </tr>
                                                    </thead>


												</div>

											</div>

													




											<div className="row col-lg-12 col-sm-12">
												<div className="BorderDescuento col-xs-12">
												<thead class="BorderDescuento">
                                                            <tr>
                                                                <th className="TexDen">
                                                                        <div class="row col-lg-3 ">
                                                                                <p className=" numeroPorcenaje col-lg-3" >{		beneficiosDM.descuentos && beneficiosDM.descuentos.length ? beneficiosDM.descuentos[2].valor : ""}%</p>
                                                                         </div>

                                                                </th>
                                                                
                                                                    <div class="row col-lg-3">
                                                                            <p className="TexDen ">{
																				beneficiosDM.descuentos && beneficiosDM.descuentos.length ? 
																				beneficiosDM.descuentos[2].descripcion
																				:""
																			
																			}</p>
                                                                            

                                                                    </div>   
                                                                
                                                            </tr>
                                                    </thead>


												</div>

											</div>
											{
								this.state.TratamientoDentalia && this.state.TratamientoDentalia.porcentajeAhorro ? 

								<div>		
											<div className="row col-xs-12 col-md-12 col-lg-12 DenPorcentajeAhorroGMM">
														<div class="row col-lg-12 col-xs-12">
															<p className="TexDen"> Hasta ahora el beneficio obtenido de la Asistencia Dental de tu Seguro Médico  
																	GNP ha sido de:
																		</p> 
																</div>
												</div>   
											<div className="row denCenterTexGMM col-xs-12 col-md-12 col-lg-12">
											
											
												<p className="denCenterTexGMM" ><span className="GMMSV1">${fnMoneda(this.state.TratamientoDentalia.porcentajeAhorro)}</span></p>	
												<div className="row  TexDen puntosBeneficiosDentalia col-xs-12 col-lg-12 col-md-12">
                                                    <p><span className="orange-point-Dentalia"></span>Precio público general: <span className="GMMSV1">${fnMoneda(beneficiosAhorroDM.precioDeSession)}</span></p>
                                                </div>
                                                <div className="row  TexDen puntosBeneficiosDentalia col-xs-12 col-lg-12 col-md-12">	
                                                    <p><span className="orange-point-Dentalia"></span>Precio preferencial: <span className="GMMSV1">${fnMoneda(beneficiosAhorroDM.pagoDespuesDeDescuento)}</span></p>
                                                </div>	
											</div>

									</div> 
									: null
							}

											<div className="row col-lg-12 col-xs-12 FootDen">
										<div className="row col-lg-12 col-xs-12">
											
												<p className="denCenterTex" >Estos servicios son otorgados a través de Dentalia</p>
                                                                            
										</div>

										<div className="row col-lg-12 col-xs-12">
											
												<p className="footerDentalia">Dentalia se hace responsable de los servicios prestados a
												trav&eacute;s de su red de cl&iacute;nicas y m&eacute;dicos en convenio, por lo que
												cualquier duda o aclaraci&oacute;n deber&aacute; ser dirigida a <a href="http://www.dentalia.com">dentalia.mx</a> o Línea GNP. 
												</p>
										</div>
									</div>	
							</div>  
							: null }

							
									{
										this.props.ramo === "V" ? 


										
										
										

										<div>     

						

										<div className="row col-lg-12 col-xs-12">
												<div className="BorderDescuento col-xs-12">
												<thead class="BorderDescuento">
                                                            <tr>
                                                                <th className="col-lg-3">
                                                                        <div class="row col-lg-3 ">
                                                                                <p className=" numeroPorcenaje col-lg-3" >{beneficiosDM.descuentos && beneficiosDM.descuentos.length ? beneficiosDM.descuentos[0].valor : ""}%</p>
                                                                         </div>

                                                                </th>
                                                                
                                                                    <div class="row col-lg-3">
                                                                            <p className="TexDen ">{
																				beneficiosDM.descuentos && beneficiosDM.descuentos.length ? 
																				beneficiosDM.descuentos[0].descripcion
																				:""
																			
																			}</p>
                                                                            

                                                                    </div>   
                                                            
                                                            </tr>
                                                    </thead>


												</div>

											</div>							
							{
								this.state.TratamientoDentalia && this.state.TratamientoDentalia.porcentajeAhorro ? 

								<div>		
												<div className="row col-xs-12 col-md-12 col-lg-12 DenPorcentajeAhorroVida">
														<div class="row col-lg-12 col-xs-12">
															<p className="TexDen"> Hasta ahora el beneficio obtenido de la Asistencia Dental de tu Seguro de Vida 
																	GNP ha sido de:
																		</p> 
																</div>
														</div>   
											<div className="row denCenterTex col-xs-12 col-md-12 col-lg-12">
										 		
													<p className="denCenterTex" ><span className="GMMSV1">${fnMoneda(this.state.TratamientoDentalia.porcentajeAhorro)}</span></p>			
													<div className="row  TexDen puntosBeneficiosDentalia col-xs-12 col-lg-12 col-md-12">
													  	  <p><span className="orange-point-Dentalia"></span>Precio público general: <span className="GMMSV1">${fnMoneda(beneficiosAhorroDM.precioDeSession)}</span></p>
													</div>	
                                                    <div className="row  TexDen puntosBeneficiosDentalia col-xs-12 col-lg-12 col-md-12">
                                                        <p><span className="orange-point-Dentalia"></span>Precio preferencial: <span className="GMMSV1">${fnMoneda(beneficiosAhorroDM.pagoDespuesDeDescuento)}</span></p>
                                                    </div>

											</div>

											<div className="row footerVidaE2 col-lg-12 col-xs-12">
										
												<p className="denCenterTex" >Estos servicios son otorgados a través de Dentalia</p>
																	
											</div>
									</div> 
									: <div>
									<div className="row footerVidaE col-lg-12 col-xs-12">
							 
									   <p className="denCenterTex" >Estos servicios son otorgados a través de Dentalia</p>
											
									 </div>
							 </div>
							}
									
							
							
									{	this.props.ramo === "G" ? 
								<div className="row col-lg-12 col-xs-12 footerVidaMas">
								
									<div className="row col-lg-12">
										
									<p className="footerDentalia">Dentalia se hace responsable de los servicios prestados a
											trav&eacute;s de su red de cl&iacute;nicas y m&eacute;dicos en convenio, por lo que
											cualquier duda o aclaraci&oacute;n deber&aacute; ser dirigida a <a href="http://www.dentalia.com">dentalia.mx</a> o Línea GNP.
											</p>
									</div>
								</div>	:null
								}
								{	
									this.props.ramo === "V" ? 
									<div className="row col-lg-12 col-xs-12 footerVidaMasD">
							
										<div className="row col-lg-12">
											
												<p className="footerDentalia">Dentalia se hace responsable de los servicios prestados a
												trav&eacute;s de su red de cl&iacute;nicas y m&eacute;dicos en convenio, por lo que
												cualquier duda o aclaraci&oacute;n deber&aacute; ser dirigida a <a href="http://www.dentalia.com">dentalia.mx</a> o Línea GNP.
												</p>
										</div>
									</div>	:null
								}								


						</div> 
						: null
									}
					
									
							
				

						


                             </div>
                        </div>
                        
                        
                        
                        
                     </div>
				</div>
			</div>
			
		);


	}
}

export default connect(mapState,mapDispatch)(Dentalia);



// WEBPACK FOOTER //
// ./src/home/dentalia.cmpt.js